import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { toast } from "react-toastify";
import { nonNumericRegex } from "../../hooks/helper";
import Select from "react-select";
import { storeBrand, storeTestimonials, updateBrand } from "../../Libs/api";
import Loader from "../../Component/Loader";
import ImageUpload from "../../Component/ImageUpload";
const EditBrand = ({ singleData, openModal, onClose, onSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState({
    title: "",
  });
  const [file, setFile] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please upload a course image");
    } else {
      setLoading(true);
      let formData = new FormData();
      formData.append("title", inputData?.title);
      formData.append("image", file);

      try {
        const apiCall = await updateBrand(formData, singleData?.id);
        if (apiCall.status) {
          console.log(apiCall, "apiCall");

          setLoading(false);
          toast.success("Record Updated Successfully!");
          onSubmit();
        } else {
          setLoading(false);

          toast.error(apiCall?.message);
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
        toast.error(error);
      }
    }
  };

  useEffect(() => {
    if (singleData?.image) {
      setFile({
        source: singleData?.image,
        options: {
          type: "local",
        },
      });
    }
  }, [singleData]);
  return (
    <Modal
      title={
        <div
          style={{
            background: "#006666",
            color: "#fff",
            padding: "12px",
            borderRadius: "4px",
          }}
        >
          Edit Brand
        </div>
      }
      centered
      open={openModal}
      onOk={() => onClose()}
      onCancel={() => onClose()}
      footer={[
        <Button
          key="ok"
          type="primary"
          style={{ background: "#006666", color: "white" }}
          disabled={loading}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          Update Brand
        </Button>,
      ]}
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center mt-3 mb-3">
                <svg className="custom-loader" viewBox="25 25 50 50">
                  <circle
                    className="custom-loader-circle"
                    r="20"
                    cy="50"
                    cx="50"
                  ></circle>
                </svg>
              </div>
            ) : (
              <div class="row mt-3">
                <div class="col-sm-12 col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Title</label>
                    <input
                      class={`form-control`}
                      type="text"
                      placeholder="Enter Title.."
                      value={inputData?.title}
                      onChange={(e) => {
                        if (
                          nonNumericRegex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          setInputData({
                            ...inputData,
                            title: e.target.value,
                          });
                        } else {
                          toast.error("Type Characters Only", {
                            toastId: "sysmbol",
                          });
                        }
                      }}
                    />
                  </div>
                </div>

                <div class="col-sm-12 col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Image</label>
                    <ImageUpload file={file} setFile={setFile} />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditBrand;
